import { registerDecorator } from 'class-validator';
/**
 * The frontend's phone field (`InputPhone`, intl-tel-input) accepts a number when
 * Google's libphonenumber calls it valid, of any number type, in any country, and
 * reads a number without a country code as German. This is the same verdict with
 * libphonenumber-js's full metadata, so the backend accepts exactly what the field
 * lets through.
 *
 * Unlike class-validator's `@IsPhoneNumber('DE')`, which refuses every number from
 * another country, `DE` here is only the default for a number written nationally.
 *
 * The metadata (~50 kB gzip) is imported lazily: the frontend imports these DTOs on
 * every page, and a static import put it into its entry bundle.
 */
export const isTelephoneNumber = async (value) => {
    if (typeof value !== 'string')
        return false;
    const { parsePhoneNumberWithError } = await import('libphonenumber-js/max');
    try {
        return parsePhoneNumberWithError(value, 'DE').isValid();
    }
    catch {
        return false;
    }
};
/** Async: Nest's `ValidationPipe` awaits it; `validateSync` would skip it. */
export function IsTelephoneNumber(validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: 'isTelephoneNumber',
            target: object.constructor,
            propertyName,
            async: true,
            constraints: [],
            options: { message: `${propertyName} must be a valid phone number`, ...validationOptions },
            validator: { validate: isTelephoneNumber },
        });
    };
}
//# sourceMappingURL=IsTelephoneNumber.decorator.js.map